export const postUrl1 = 'https://all.madagx.com';
export const postUrl2 = 'https://new.madagx.com';
// export const postUrl1 = 'http://100.121.6.88:3000';
// export const postUrl2 = 'http://100.121.6.88:3004';

export const apiUrl1 = postUrl1 + '/graphql';
export const apiUrl2 = postUrl2 + '/graphql';



// WEBPACK FOOTER //
// ./src/graphql/url.js